export default {
  RESET_STATE: 'scheduling/resetState',
  UPDATE_SELECTED_DOCTORS: 'scheduling/updateSelectedDoctors',
  REMOVE_SELECTED_DOCTOR: 'scheduling/removeSelectedDoctor',
  UPDATE_PREFERENCE_ORDER: 'scheduling/updatePreferenceOrder',
  SET_DOCTOR_PREFERENCES: 'scheduling/setDoctorPreferences',
  SELECT_AVAILABILITY: 'scheduling/selectAvailability',
  SET_HAS_PERSONAL_DOCTOR_ON_FILE: 'scheduling/setHasPersonalDoctorOnFile',
  SET_PCPS_ON_FILE: 'scheduling/setPcpsOnFile',
  SET_IS_FETCHING_PCPS_ON_FILE: 'scheduling/setIsFetchingPcpsOnFile',
  SET_HEALTH_PLAN_REQUIRES_PERSONAL_DOCTOR:
    'scheduling/setHealthPlanRequiresPersonalDoctor',
  RESET_AVAILABILITY: 'scheduling/resetAvailability',
  RESET_DOCTOR: 'scheduling/resetDoctor',
  KEEP_ONLY_FIRST_DOCTOR: 'scheduling/keepOnlyFirstDoctor',
  SET_RECOMMENDED_DOCTORS: 'scheduling/setRecommendedDoctors',
  SET_ZIP_CODE: 'scheduling/setZipCode',
  SET_IS_FETCHING_PROVIDERS: 'scheduling/setIsFetchingProviders',
  SET_SCHEDULED_APPOINTMENT: 'scheduling/setScheduledAppointment',
  SET_IS_FETCHING_SCHEDULED_APPOINTMENT:
    'scheduling/setIsFetchingScheduledAppointment',
}
